export default __webpack_public_path__ + "static/balance_1-46a2af769e85a9985efef1997f790ffc.jpg";